const Ls12PosicionesSacarGases = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                    <h1 className='titulo--lesson--color--1'>Posiciones para <span className='titulo--lesson--color--2'>sacar gases</span></h1>

                    <h1 className="text--subtitulo p-4">Cada vez que termine de alimentar a su beb&eacute;, es importante que usted lo ayude a eliminar los gases</h1>

                    <div className="container">
                        <div className="row d-flex align-items-center">
                            <div className="col-4 text-center">
                                <img src="./img/Ls12Posicion-1.png" className='' />
                            </div>
                            <div className="col-8">
                                <div className="texto--parrafo bg-white rounded">
                                    <p className="p-3">Siente al beb&eacute; en sus piernas. Con la palma de su mano, soporte su pecho mientras con sus dedos le sostiene la quijada. Masajee suavemente su espalda dando peque&ntilde;os c&iacute;rculos.</p>
                                </div>

                            </div>
                        </div>

                        <div className="row d-flex align-items-center">
                            <div className="col-4 text-center">
                                <img src="./img/Ls12Posicion-2.png" className='' />
                            </div>
                            <div className="col-8">
                                <div className="texto--parrafo bg-white rounded">
                                    <p className="p-3">Alce a su beb&eacute; de modo que la barbilla quede apoyada sobre su hombro y masajee suavemente su espalda dando peque&ntilde;os c&iacute;rculos.</p>
                                </div>

                            </div>
                        </div>

                        <div className="row d-flex align-items-center">
                            <div className="col-4 text-center">
                                <img src="./img/Ls12Posicion-3.png" className='' />
                            </div>
                            <div className="col-8">
                                <div className="texto--parrafo bg-white rounded">
                                    <p className="p-3">Acueste al beb&eacute; bocabajo en sus piernas. Soporte la quijada del beb&eacute; con una mano, asegurando que la cabeza no se encuentre en una posici&oacute;n inferior a la del resto del cuerpo, y masajee suavemente su espalda dando peque&ntilde;os c&iacute;rculos.</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='container ps-4 pt-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='http://www.babycenter.com/0_how-to-burp-your-baby_10363676.bc'>http://www.babycenter.com/0_how-to-burp-your-baby_10363676.bc</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls12PosicionesSacarGases;